import React from "react";
import { connect } from "react-redux";
import { Flex } from "/app/src/component";
import TextareaAutosize from "react-autosize-textarea";
import { SVGButton, MarkdownEditor } from "/app/src/component";
import { FAQModel } from "/app/src/model";
import PaymentConfigHandler from "/app/src/config/PaymentConfigHandler";

import style from "./ListItem/style.css";

class Item extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screen: "normal",
      question: "",
      answer: "",
    };

    this._renderNormalState = this._renderNormalState.bind(this);
    this._renderEditorState = this._renderEditorState.bind(this);
    this._handleQuestionEdit = this._handleQuestionEdit.bind(this);
    this._handleAnswerEdit = this._handleAnswerEdit.bind(this);

    this._toEditor = this._toEditor.bind(this);
    this._toNormal = this._toNormal.bind(this);

    this._saveToDatabase = this._saveToDatabase.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.currentItem !== 0) {
      this.setState({ screen: "normal", question: "", answer: "" });
    }
  }

  _toEditor() {
    const limit = PaymentConfigHandler.checkAccess("faq", "admin");
    const { nbrFAQ } = this.props;
    if (limit !== "unlimited" && nbrFAQ + 1 > limit) {
      return;
    }
    this.props._onClick(); // from above, making sure we become element in focus in the list
    this.setState({ screen: "edit" });
  }
  _toNormal() {
    this.props._onClick(); // from above, making sure we become element in focus in the list
    this.setState({ screen: "normal", question: "", answer: "" });
  }

  _handleQuestionEdit(event) {
    this.setState({ question: event.target.value });
  }
  _handleAnswerEdit(text) {}
  _saveToDatabase() {
    this.props.createFaqItem(
      this.state.question,
      this.state.answer,
      null,
      null,
      null
    );
    this.setState({ screen: "normal", question: "", answer: "" });
  }

  _renderNormalState() {
    return (
      <Flex
        onClick={this._toEditor}
        className={style.FAQAdd}
        center
        height="60px"
        fontWeight="500"
        backgroundColor="darkwhite"
        borderRadius="60px"
        mb="2px"
        color="black"
      >
        {" "}
        + Lägg till fråga{" "}
      </Flex>
    );
  }
  _renderEditorState() {
    return (
      <Flex width="100%" className={style.FAQItem}>
        <Flex column grow height="100%" padding="10px 34px 10px 34px" mb="50px">
          <Flex column grow>
            <Flex className={style.FAQItemQuestionTextArea}>
              <TextareaAutosize
                value={this.state.question}
                onChange={this._handleQuestionEdit}
                placeholder="Skriv din fråga"
              />
            </Flex>
            <Flex className={style.FAQItemAnswerTextArea} grow>
              <MarkdownEditor
                height="250px"
                text={this.state.answer}
                onTextChange={(rawJson) => {
                  this.setState({ answer: rawJson });
                }}
              />
            </Flex>
          </Flex>
        </Flex>

        <Flex hAlignContent="center" basis="15%">
          <Flex
            className={style.FAQItemOptions}
            column
            vAlignContent="center"
            hAlignContent="center"
            border
          >
            <Flex mb="20px" mt="10px">
              <SVGButton
                src="/images/Save.svg"
                onClick={this._saveToDatabase}
                color="darkgrey"
                hover="blue"
                border
                width="100%"
              />
            </Flex>
            <Flex>
              <SVGButton
                src="/images/Return.svg"
                onClick={this._toNormal}
                color="darkgrey"
                hover="blue"
                border
                width="100%"
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    );
  }
  render() {
    switch (this.state.screen) {
      case "edit":
        return this._renderEditorState();
      case "normal":
      default:
        return this._renderNormalState(this.state.screen);
    }
  }
}

const { dispatcher: faqCreateDispatcher } = FAQModel.createItemRequest();

const mapDispatchToProps = (dispatch, props) => ({
  createFaqItem: (question, answer, authorName, authorImg, categoryId) => {
    dispatch(
      faqCreateDispatcher(question, answer, authorName, authorImg, categoryId)
    );
  },
});

export default connect(null, mapDispatchToProps)(Item);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/FAQ/Normal/AddNewQuestion.js